export default "__VITE_ASSET__N$_km_lL__"